import React, { useContext } from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useDispatch } from 'react-redux';
import { setHelpTicketDetails } from '../../Store/Slices/authSlice';
import { origin } from '../../JS/Common';
import useConfig from '../../Hooks/useConfig';

export default function Thankyou() {
    const {third_party_page_logo}  = useConfig();
    const reduxDispatch = useDispatch();
    reduxDispatch(setHelpTicketDetails(null));
    const pathname = window.location.pathname;
    const pathArray = pathname.split('/');
    const hdId = pathArray[2];
    const schoolnumber = pathArray[3];
    const reqnum = pathArray[4];
    const guid = pathArray[5]
    const url = `${origin}/helpdesk-ticket/${hdId}/${schoolnumber}/${reqnum}/${guid}`;
    return (
        <>
            <LazyLoadImage src="/images/LoginBg.png" alt="" className="MainDiv-bg-image" />
            <div className="position-relative MainDiv">
                <div className='col-md-8 offset-md-2 d-flex align-items-center' style={{ height: '100vh' }}>
                    <div className="GridBox mx-auto text-center p-4 ">
                        <div className="my-4">
                            {third_party_page_logo ?
                                <img src={third_party_page_logo} className="img-fluid" alt="Logo" />
                                :
                                <img src="/images/LoginLogo.png" className="img-fluid" alt="Logo" />
                            }
                        </div>

                        <h5 className='py-3 text-center'>
                            {schoolnumber == undefined ?
                                <p>Thank you for submitting your Help Desk!</p>
                                :
                                <>
                                    <p className='pt-1' >Your Help Desk request has been generated successfully.</p>
                                    <p className='pt-1'>You can view the details of your Help Desk request by clicking <a href={url}><u>here</u>.</a></p>
                                    <p className='pt-1'>You will receive a notification on your email when any action is taken on your Ticket.</p>
                                    <p className='pt-1'> Thank You!</p>
                                </>
                            }
                        </h5>
                    </div>
                </div>
            </div>
        </>
    )
}
